export async function MainGestor_v1(transactionId, send, sec_3ds_init, sec_3ds_aut, CCA, reference, app) {
  try {
    const apiUrl = process.env.REACT_APP_MainGestor_v1;
    const data = {
      transactionId: transactionId,
      send: send,
      sec_3ds_init: sec_3ds_init,
      sec_3ds_aut: sec_3ds_aut,
      CCA : CCA,
      referenceId: reference,
      app: app
    };

    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify( data )
    });

    if (!response.ok) throw new Error('Error al obtener datos');
    
    return await response.json();
  } catch (error) {
    console.error('Error al llamar al API:', error);
    throw error;
  }
}
